import { ReactNode } from "react";
import { Region } from "../Region";
import { Alerts } from "./Alerts/Alerts";
import { Billing } from "./Billing/Billing";
import { useBilling } from "./useBilling";

export const BillingRegion = ({ children }: { children: ReactNode }) => {
  return <Region title="Upcoming Bills" contentSlot={children} />;
};

type BillingAlertsProps = {
  showBilling: boolean;
};

export const BillingAlerts = ({ showBilling }: BillingAlertsProps) => {
  const billingDetails = useBilling();

  return (
    <>
      <Alerts billingDetails={billingDetails} />

      {showBilling && (
        <BillingRegion>
          <Billing billingDetails={billingDetails} />{" "}
        </BillingRegion>
      )}
    </>
  );
};
